import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["password", "confirmation", "hint", "submit"]

  check() {
    const pass = this.passwordTarget.value
    const conf = this.confirmationTarget.value

    if (!conf) {
      this.hintTarget.style.display = "none"
      this.confirmationTarget.classList.remove("profile-edit__input--error")
      return
    }

    if (pass === conf) {
      this.hintTarget.style.display = "flex"
      this.hintTarget.className = "profile-edit__hint profile-edit__hint--success"
      this.hintTarget.innerHTML = '<iconify-icon icon="solar:check-circle-linear" width="14" height="14"></iconify-icon> Senhas coincidem'
      this.confirmationTarget.classList.remove("profile-edit__input--error")
      this.submitTarget.disabled = false
    } else {
      this.hintTarget.style.display = "flex"
      this.hintTarget.className = "profile-edit__hint profile-edit__hint--error"
      this.hintTarget.innerHTML = '<iconify-icon icon="solar:close-circle-linear" width="14" height="14"></iconify-icon> Senhas não coincidem'
      this.confirmationTarget.classList.add("profile-edit__input--error")
      this.submitTarget.disabled = true
    }
  }
}
